module.exports = __webpack_public_path__ + "img/input-count-minus.1bf4c210.svg";